import ProjectsItem from './ProjectsItem'
import Row from 'react-bootstrap/Row'
import RegisterModal from '../User/RegisterModal'
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/Auth';
import { supabase } from "../../utils/supabaseClient"
import { toggleLikes } from "../utils.js"

export default function ProjectsList(props) {

    const [ registerModal, setRegisterModal] = useState(false)
    const [ projects, setProjects ] = useState(props.projects)
    const [ profileId, setProfileId ] = useState(null)
    const { user, signInGoogle, signOut, signIn } = useAuth();

    const getProjects = async () => {
        const { data, error } = await supabase
            .from('main_profile')
            .select(`
                id,
                main_like (
                    project (
                        id,
                        votes
                    )
                )
            `)
            .filter("user","eq", user.id)
            .not('main_like.project','is', null)

        //filter foreign key
        error && console.log(error)

        // insert like boolean in each corresponding project object 
        let { data:newArr, error1 } = await supabase.from("main_project").select().order('id', { ascending: true })
        console.log(data[0].main_like)
        for (let i = 0; i < data[0].main_like.length; i++) {
            const likeProjectId = data[0].main_like[i].project.id
            const index = newArr.findIndex(p => p.id === likeProjectId)
            newArr[index]["like"] = true
            newArr[index]["votes"] = data[0].main_like[i].project.votes
        }
        !profileId && setProfileId(data[0].id)
        setProjects([...newArr])
    }


    //don't run if user is not logged in
    if (user && !profileId){
        getProjects()
    }

    
    const handleLikes = async (e, bool, projectId, profileId) => {
        await toggleLikes(e, bool, projectId, profileId)
        await getProjects()
    }



    return(
        <>
            <RegisterModal 
                        show={registerModal} 
                        signInGoogle={signInGoogle} 
                        signIn={signIn}
                        setShow={setRegisterModal}
                        
                    />
            <Row md={3}>
                {projects.map((project) => (<ProjectsItem 
                                                key={project.id} 
                                                project={project} 
                                                user={user} 
                                                setRegisterModal={setRegisterModal} 
                                                like={project.like}
                                                handleLikes={handleLikes}
                                                profileId={profileId} />
                                            ))}
            </Row>
        </>
    )
}